import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { useCallback } from 'react';
import { Dropdown, DropdownDivider } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

const LinksDropDown = () => {
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const onLinkOpened = useCallback(
    (link: string) => sgwtWebAnalytics?.trackEvent('Header', 'Open link', link),
    [sgwtWebAnalytics],
  );

  return (
    <Dropdown className="dropdown-center">
      <Dropdown.Toggle variant="discreet" className="btn-discreet-discreet navbar-link">
        Cash and Option tools
      </Dropdown.Toggle>

      <Dropdown.Menu data-e2e="menu">
        <Dropdown.Item
          href="https://insight.sgmarkets.com/page/forex"
          onClick={() => onLinkOpened('https://insight.sgmarkets.com/page/forex')}
          target="_blank"
          rel="noopener"
        >
          <FormattedMessage id="header.strategyReports" values={outIcon} />
        </Dropdown.Item>
        <Dropdown.Item
          href="https://insight.sgmarkets.com/page/tradinginsight"
          onClick={() => onLinkOpened('https://insight.sgmarkets.com/page/tradinginsight')}
          target="_blank"
          rel="noopener"
        >
          <FormattedMessage id="header.marketCommentary" values={outIcon} />
        </Dropdown.Item>
        <Dropdown.Item
          href="https://insight.sgmarkets.com/page/salesfss"
          onClick={() => onLinkOpened('https://insight.sgmarkets.com/page/salesfss')}
          target="_blank"
          rel="noopener"
        >
          <FormattedMessage id="header.g10EMFXvolMonitor" values={outIcon} />
        </Dropdown.Item>

        <DropdownDivider data-e2e="separator" />

        <Dropdown.Item
          href="https://analytics.sgmarkets.com/fxeagleeye/?currencyPair=EUR%2FUSD&size=100M&duration=15&resultFormat=Pips&riskLevel=50&pk_campaign=SGMarketsFX&pk_kwd=Fx%20Eagle%20Eye"
          onClick={() =>
            onLinkOpened(
              'https://analytics.sgmarkets.com/fxeagleeye/?currencyPair=EUR%2FUSD&size=100M&duration=15&resultFormat=Pips&riskLevel=50&pk_campaign=SGMarketsFX&pk_kwd=Fx%20Eagle%20Eye',
            )
          }
          target="_blank"
          rel="noopener"
        >
          <FormattedMessage id="header.eagleEye" values={outIcon} />
        </Dropdown.Item>
        <Dropdown.Item
          href="https://analytics.sgmarkets.com/fxvol/?pk_campaign=SGMarketsFX&pk_kwd=Fx%20Vol%20Wizard"
          onClick={() =>
            onLinkOpened('https://analytics.sgmarkets.com/fxvol/?pk_campaign=SGMarketsFX&pk_kwd=Fx%20Vol%20Wizard')
          }
          target="_blank"
          rel="noopener"
        >
          <FormattedMessage id="header.volWizard" values={outIcon} />
        </Dropdown.Item>
        <Dropdown.Item
          href="https://analytics.sgmarkets.com/fxeventtracker/?pk_campaign=SGMarketsFX&pk_kwd=Fx%20Event%20Tracker"
          onClick={() =>
            onLinkOpened(
              'https://analytics.sgmarkets.com/fxeventtracker/?pk_campaign=SGMarketsFX&pk_kwd=Fx%20Event%20Tracker',
            )
          }
          target="_blank"
          rel="noopener"
        >
          <FormattedMessage id="header.eventTracker" values={outIcon} />
        </Dropdown.Item>

        <DropdownDivider data-e2e="separator" />

        <Dropdown.Item
          href="https://doc.sgmarkets.com/en/3/0/414010/319949.html?sid=bf0adc8d018e33fa384994fb0189c52c"
          onClick={() =>
            onLinkOpened('https://doc.sgmarkets.com/en/3/0/414010/319949.html?sid=bf0adc8d018e33fa384994fb0189c52c')
          }
          target="_blank"
          rel="noopener"
        >
          <FormattedMessage id="header.fxoTraining" values={outIcon} />
        </Dropdown.Item>
        <Dropdown.Item
          href="https://insight.sgmarkets.com/page/algo-fx-execution"
          onClick={() => onLinkOpened('https://insight.sgmarkets.com/page/algo-fx-execution')}
          target="_blank"
          rel="noopener"
        >
          <FormattedMessage id="header.fxAlgos" values={outIcon} />
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default LinksDropDown;

const outIcon = { out: <i className="icon icon-sm ms-1">launch</i> };
